import React, { useCallback, useEffect } from "react";
import "./ContactEditorial.css";
import contact_page_banner from "../../assets/faq/contact_page_banner.png"; // replace with your image path
import { hideContact, setContactData, showFaq, showHeroBanner } from "../../features/serviceSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ContactEditorial = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        contact_data
    } = useSelector(state => state.service);
    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_CUSTOM_API+"/contact"
            );
            dispatch(setContactData(response.data));

        } catch (error) {
            console.error("API error:", error);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    return (
        <section className="contact-editorial">
            {/* Left Vertical Label */}
            {/* <div className="vertical left">CONTACT US</div> */}

            {/* Right Vertical Label */}
            {/* <div className="vertical right">MEMBERSHIP SERVICES</div> */}

            {/* Top Row */}
            <div className="top-row">
                <div className="contact-label-column">
                    <button
                        type="button"
                        className="contact-close-btn"
                        onClick={(event) => {
                            event.stopPropagation();
                            dispatch(hideContact());
                            dispatch(showHeroBanner());
                            navigate("/services");
                        }}
                    >
                        &#10005; Close
                    </button>
                    <div className="boutique-label">SUDSIES BOUTIQUES</div>
                </div>

                <div className="contact-right">
                    <ul className="boutique-list">
                        <li>
                            <a href="https://sudsies.com/north-miami-dry-cleaner/" target="_blank" rel="noopener noreferrer">
                                NORTH MIAMI BOUTIQUE
                            </a>
                        </li>
                        <li>
                            <a href="https://sudsies.com/miami-beach-dry-cleaner/" target="_blank" rel="noopener noreferrer">
                                MIAMI BEACH BOUTIQUE
                            </a>
                        </li>
                        <li>
                            <a href="https://sudsies.com/miami-design-district-dry-cleaner/" target="_blank" rel="noopener noreferrer">
                                MIAMI DESIGN DISTRICT BOUTIQUE
                            </a>
                        </li>
                        <li>
                            <a href="https://sudsies.com/fort-lauderdale-dry-cleaner/" target="_blank" rel="noopener noreferrer">
                                FORT LAUDERDALE BOUTIQUE
                            </a>
                        </li>
                        <li>
                            <a href="https://sudsies.com/boca-raton-dry-cleaner/" target="_blank" rel="noopener noreferrer">
                                BOCA RATON BOUTIQUE
                            </a>
                        </li>
                    </ul>
                    {/* Hero Image */}
                    <div className="hero">
                        <img src={contact_page_banner} alt="Hero" />
                        <h2>
                            We Are <span>At Your</span>
                            <br />
                            <span>Services</span>
                        </h2>
                    </div>

                    {/* Inquiry Grid */}
                    <div className="inquiry-grid">
                        <div className="card">
                            <h3>GENERAL<br />INQUIRIES</h3>
                            <p className="muted">
                                Black Label Member<br />
                                Relations. Mon-Fri 9am to 6p.m.
                            </p>
                            {contact_data?.phone ? (
                                <a href={`tel:${contact_data.phone}`}>Tel. {contact_data.phone}</a>
                            ) : (
                                <span>Tel. </span>
                            )}
                        </div>

                        <div className="card">
                            <h3>EMAIL<br />INQUIRIES</h3>
                            <p className="muted">
                                A Black Label Ambassador will respond as soon as possible
                            </p>
                            <a href={`mailto:${contact_data?.email}`}>
                                Send an Email
                            </a>
                        </div>

                        <div className="card">
                            <h3>SCHEDULE AN<br />APPOINTMENT</h3>
                            <p className="muted">
                                Schedule a consultation appointment at your home, office, or vessel
                            </p>
                            <a href={`mailto:${contact_data?.email}`}>Send an Email</a>
                        </div>

                        <div onClick={() => {
                            dispatch(hideContact());
                            dispatch(showFaq());
                            navigate(`/faq`);

                        }} className="card faq">
                            <h3>FAQ<br />INQUIRIES</h3>
                            <p className="muted">
                                Find answers to commonly raised questions
                            </p>
                            <button
                                type="button"
                                className="link-like"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(hideContact());
                                    dispatch(showFaq());
                                    navigate(`/faq`);
                                }}
                            >
                                Explore FAQ
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <aside className=" side-vertical-heading right-minus-16">
                <span>CONTACT US</span> <span className="spacer"></span> <span>MEMBERSHIP SERVICES</span>
            </aside>


        </section>
    );
};

export default ContactEditorial;
